module.exports = function(data) {
var __t, __p = '';
__p += '<h2 class="saved-filters-header">' +
((__t = ( strings.savedFiltersStr )) == null ? '' : __t) +
'</h2>\n<div class="saved-filters"></div>';
return __p
}